module.exports = __webpack_public_path__ + "img/2w.d3604d75.svg";